/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jesse on 5/6/16.
 */
'use strict';
angular.module('prism-ui.package').controller('PMMetadataSearchFieldsSectionController', function ($scope, _, $q, SearchFilterService, MetadataService) {
	var self = this;

	self.searchablePackageFields = [
		{id: '1', selected: true, fieldName:'id', name:'ID'},
        {id: '2', selected: false, fieldName:'keywords', name:'Keywords'},
		{id: '3', selected: false, fieldName:'desc1', name:'Short Description'},
        {id: '4', selected: true, fieldName:'name', name:'Nickname'},
		{id: '5', selected: false, fieldName:'desc2', name:'Long Description'},
        {id: '6', selected: true, fieldName:'episodeTitle', name:'Title'},
		{id: '7', selected: false, fieldName:'tMSId', name:'TMS ID'}
	];

	var getDefaultPackageSearchFields = function () {
		var searchable = [];
		angular.forEach(self.searchablePackageFields, function (field) {
			if (field.selected) {
				searchable.push(field);
			}
		});
		return searchable;
	};

	var retrieveData = function () {
		MetadataService.propertiesPromise.then(() => {
			self.searchablePartnerFields = _.filter(MetadataService.searchableProperties, (property) => !property.mvpd);
			var packageProps = SearchFilterService.getObjectsFromPathProp(self.searchablePackageFields, 'fieldName', 'packageProperties');
			self.selectedSearchablePackageFields = packageProps.length ? packageProps : getDefaultPackageSearchFields();
			self.selectedSearchablePartnerFields = SearchFilterService.getObjectsFromPathProp(self.searchablePartnerFields, 'name', 'partnerProperties');
		});
	};

	retrieveData();

	$scope.$on('modal.closing', function () {
		SearchFilterService.searchCriteria.packageProperties = SearchFilterService.extractQueryProp(self.selectedSearchablePackageFields, 'fieldName');
		SearchFilterService.searchCriteria.partnerProperties = SearchFilterService.extractQueryProp(self.selectedSearchablePartnerFields, 'name');
	});
});
